import { type FunctionComponent, useState } from 'react'
import { useIntl } from 'react-intl'
import { OpenInIcon } from '@instacart/ids-core'
import { MenuBase, Divider, NavigationBar } from '@retailer-platform/shared-components/src/tds'
import { TdsMenuItem } from './TdsMenuItem'
import { useTdsHelpMenuLinks } from './useTdsHelpMenuLinks'
import { UserFeedbackSurveyController } from '../../common/retailer-satisfaction-survey/user-feedback/UserFeedbackSurveyController'
import { useUserFeedbackContext } from '../user-feedback/UserFeedbackContext'
import { useTopBarMenu } from './TopBarMenuContext'

export const TdsHelpMenu: FunctionComponent = () => {
  const intl = useIntl()
  const { isOpen, setIsOpen } = useTopBarMenu('help')
  const [showFeedback, setShowFeedback] = useState(false)
  const { hideFeedbackButton, showFeedbackButton } = useUserFeedbackContext()
  const menuLinks = useTdsHelpMenuLinks()

  const handleFeedbackClick = () => {
    setIsOpen(false)
    setShowFeedback(true)
    hideFeedbackButton()
  }

  const handleFeedbackClose = () => {
    setShowFeedback(false)
    showFeedbackButton()
  }

  const trigger = (
    <NavigationBar.Button
      aria-label={intl.formatMessage({ id: 'app.nav.helpMenu.label' })}
      icon="help"
      isActive={isOpen}
      onPress={() => setIsOpen(!isOpen)}
    />
  )

  return (
    <>
      <MenuBase target={trigger} isOpen={isOpen} onMenuStateChange={setIsOpen} position="bottomEnd">
        {menuLinks.map(({ href, messageId }) => (
          <TdsMenuItem
            key={messageId}
            text={intl.formatMessage({ id: messageId })}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            trailingIcon={OpenInIcon}
          />
        ))}
        <Divider />
        <TdsMenuItem
          text={intl.formatMessage({ id: 'give_feedback' })}
          onClick={handleFeedbackClick}
        />
      </MenuBase>
      {showFeedback && <UserFeedbackSurveyController onClose={handleFeedbackClose} />}
    </>
  )
}
